export function createWindowSlotId(registryFormId: string, token?: string): string {
  const baseId = String(registryFormId ?? '').trim()
  const rawToken =
    token != null && String(token).trim() !== ''
      ? String(token)
      : `${Date.now()}_${Math.random().toString(36).slice(2, 10)}`
  const safeToken = rawToken.replace(/[^a-zA-Z0-9_.-]/g, '_')
  return `${baseId}_win_${safeToken}`
}

/**
 * Ключ pagesData для NEW_WINDOW
 */
export function resolveNewWindowPageSlotId(
  responseFormId: string,
  options: {
    parentPageSlotId?: string | null
    sessionId?: string | null
    windowType?: string
  } = {},
): string {
  const fid = String(responseFormId ?? '').trim()
  const wt = String(options.windowType ?? '').toUpperCase()
  if (wt !== 'NEW_WINDOW') {
    return fid
  }
  const parent = String(options.parentPageSlotId ?? '').trim()
  const token =
    options.sessionId != null && String(options.sessionId).trim() !== ''
      ? String(options.sessionId)
      : undefined
  return createWindowSlotId(parent || fid, token)
}

/**
 * Ключ pagesData для SAME_WINDOW: заменить контент в слоте исходной формы
 */
export function resolveSameWindowPageSlotId(options: {
  sourcePageSlotId?: string | null
  openedFormId?: string | null
} = {}): string {
  const source = String(options.sourcePageSlotId ?? '').trim()
  if (source) {
    return source
  }
  return String(options.openedFormId ?? '').trim()
}

/** Событие для remount формы после замены layout в том же slot id. */
export const SAME_WINDOW_REPLACE_EVENT = 'workflow:same-window-replace'

export function dispatchSameWindowReplace(slotId: string): void {
  const id = String(slotId ?? '').trim()
  if (!id || typeof window === 'undefined') {
    return
  }
  window.dispatchEvent(new CustomEvent(SAME_WINDOW_REPLACE_EVENT, { detail: { slotId: id } }))
}
